const ITEMS = [
  "HYDRATATION PROFONDE",
  "EFFET GLASS-SKIN",
  "BIO-COLLAGÈNE",
  "FORMULE SANS PARABÈNE",
  "4 ACIDES HYALURONIQUES",
  "RITUEL RELAX 2026",
];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden bg-rose-gold/90 py-4 select-none">
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif italic text-lg sm:text-xl text-onyx/90 px-6">{item}</span>
                <span className="text-onyx/60 text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
